<template>
  <div class="flex">
    <div class="w-menu mr-2">
      <img v-on:click="toggle(1)" v-bind:src="getIcon(star1)" />
    </div>
    <div class="w-menu mr-2">
      <img v-on:click="toggle(2)" v-bind:src="getIcon(star2)" />
    </div>
    <div class="w-menu mr-2">
      <img v-on:click="toggle(3)" v-bind:src="getIcon(star3)" />
    </div>
    <div class="w-menu mr-2">
      <img v-on:click="toggle(4)" v-bind:src="getIcon(star4)" />
    </div>
    <div class="w-menu mr-2">
      <img v-on:click="toggle(5)" v-bind:src="getIcon(star5)" />
    </div>
  </div>
  <div v-text="desc" class="flex-grow text-sm font-bold papsi-rating-lh"></div>
  <div class="flex mt-4 mb-2 text-sm">
    <span v-if="this.value == 5">{{ lang("lbl_0000234") }}</span>
    <span v-else>{{ lang("lbl_0000235") }}</span>
  </div>
  <div class="flex flex-wrap justify-center items-center mb-2">
    <div
      v-for="(category, index) in this.categories"
      @click="toggleCategory(category)"
      :key="index"
      class="font-medium rounded-full text-sm py-2 px-3 mr-3 mt-3"
      :class="{
        'bg-secondary-light text-secondary-dark': selected_categories.includes(category),
        'bg-grey-lighter text-grey-darkest': !selected_categories.includes(category),
      }"
    >
      {{ category }}
    </div>
  </div>
</template>

<script>
import Support from "./../../services/Support.js";
import mixin from "./../../mixin.js";

export default {
  name: "v-rating",
  mixins: [mixin],
  props: {
    type: {
      type: Number,
    },
    submit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      uuid: null,
      value: 5,
      star1: true,
      star2: true,
      star3: true,
      star4: true,
      star5: true,
      desc: "",
      descriptions: [],
      categories: [],
      selected_categories: [],
    };
  },
  mounted() {
    const description_start = 203;
    const description_end = 207;
    const category_start = 227;
    const category_end = 233;

    this.uuid = this.$store.state.uuid;

    for (let i = description_start; i <= description_end; i++) {
      this.descriptions.push(this.lang(`lbl_0000${i}`));
    }

    for (let i = category_start; i <= category_end; i++) {
      this.categories.push(this.lang(`lbl_0000${i}`));
    }
    this.toggle(5);
  },
  methods: {
    getIcon(status) {
      return require(status
        ? "@/assets/icons/papsi_star_on.svg"
        : "@/assets/icons/papsi_star_off.svg");
    },
    toggle(n) {
      this.desc = this.descriptions[n - 1];
      this.value = n;

      if (n == 1) {
        this.star1 = true;
        this.star2 = false;
        this.star3 = false;
        this.star4 = false;
        this.star5 = false;
      } else if (n == 2) {
        this.star1 = true;
        this.star2 = true;
        this.star3 = false;
        this.star4 = false;
        this.star5 = false;
      } else if (n == 3) {
        this.star1 = true;
        this.star2 = true;
        this.star3 = true;
        this.star4 = false;
        this.star5 = false;
      } else if (n == 4) {
        this.star1 = true;
        this.star2 = true;
        this.star3 = true;
        this.star4 = true;
        this.star5 = false;
      } else if (n == 5) {
        this.star1 = true;
        this.star2 = true;
        this.star3 = true;
        this.star4 = true;
        this.star5 = true;
      }

      // this.$emit('toggled', n);
    },
    toggleCategory(category) {
      const index = this.selected_categories.indexOf(category);
      if (index === -1) {
        this.selected_categories.push(category);
      } else {
        this.selected_categories.splice(index, 1);
      }
    },
    submitRate(n) {
      const remarks = JSON.stringify(this.selected_categories);
      Support.add(this.uuid, this.type, n, remarks)
        .then(() => {
          // that.$emit('submitted');
        })
        .catch((error) => {
          // that.$emit('submitted');
          this.$terminate(error.response.status);
        });
    },
  },
  watch: {
    submit(n) {
      if (n) {
        this.submitRate(this.value);
      }
    },
  },
};
</script>

<style scoped>
.papsi-rating-lh {
  line-height: 32px;
}
</style>
